/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import { Input, InputProps } from '@chakra-ui/react'
import React from 'react'

const InputField = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return <Input ref={ref} {...props} />
})

export default InputField
